var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMagnifierLine24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.3 15.3c.76-.75 1.79-1.98 1.78-3.08 0-.47-.13-.86-.37-1.15-.39-.49-.88-.75-1.4-.76-.53 0-1.02.27-1.4.76-.24.3-.36.69-.37 1.15 0 1.1.92 2.26 1.68 3.01",
  stroke: "#222B3E",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3 15.3a7.467 7.467 0 0 1-5.3 2.2c-4.14 0-7.5-3.36-7.5-7.5a7.499 7.499 0 0 1 14.57-2.5M15.3 15.3 21 21",
  stroke: "#222B3E",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIcMagnifierLine24X24;